import { defineStore } from "pinia";

// The admin page this tab left through "User login", so the user dashboard's
// Admin button can lead back to it. The tab's storage carries the path from one
// bundle to the other, which works only while both portals share an origin: an
// admin portal on its own public URL keeps a storage the user portal cannot
// read, and its Admin button goes to the portal's landing page instead.
// Reset at admin sign-out (queries/session.ts).
export const useAdminReturnStore = defineStore("adminReturn", {
  state: () => ({
    path: "",
  }),

  getters: {
    // Only a path inside the admin portal is followed, and anything else in
    // storage reads as nothing saved.
    returnPath: (state): string => (state.path.startsWith("/admin/") ? state.path : ""),
  },

  actions: {
    remember(path: string) {
      this.path = path;
    },
  },

  // Written at once: the link that sets it unloads the page straight after.
  persist: { flush: "sync" },
});
